// This file should eventually be called lazyIndex but for now we have to entry points, one on the index.ts and one on this file.
// so naming it differently so we don't break the pattern of having someone point directly to a lazyIndex file

import 'owa-bootstrap'; // Important that owa-bootstrap come first, in order to bootstrap webpack settings
import 'owa-application'; // Import owa-application here to include globalStyles

// Initialize mail packages here:
import 'owa-mail-module-actions';
import 'owa-mail-compose-store';
import 'owa-mail-focused-inbox-config';
import 'owa-mail-folder-store';
import 'owa-mail-list-actions';
import 'owa-mail-module-orchestrator';
import 'owa-mail-optin';
import 'owa-mail-reading-pane-store';
import 'owa-mail-web-notification';
import 'owa-lightning-view';
import 'owa-boot-cache';
import 'owa-mail-folder-orchestration';
import 'owa-mail-items-store-actions';
import 'owa-webpush-notifications';
import 'owa-mail-list-selection-actions-v2';
import 'owa-mail-cloudcachemailbox';
import 'owa-mail-iris';
import 'owa-selected-calendars-user-config';
import 'owa-mail-nudge-actions';

// Import orchestrators in mail bootstrap
import './orchestrators/onNewMailNotificationClicked';
import './orchestrators/onLikeNotificationClicked';

export { default as bootstrapMailModule } from './bootstrapMailModule';
